module.exports = __webpack_public_path__ + "img/DAPChart2.00bf12ee.png";